import { QueryClient } from '@tanstack/react-query';
import retryApiRequest from './api/retryApiRequest';

// a minute of freshness keeps remounts and tab switches from refetching, while
// still revalidating often enough for portal data. refetchOnWindowFocus is off
// because the portal is a long-lived tab and focus refetches would be constant.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: retryApiRequest,
      refetchOnWindowFocus: false
    }
  }
});

export default queryClient;
